module.exports = __webpack_public_path__ + "img/invite.1768119790257.png";